import { publicAsset } from '../lib/assets';
import { createEl } from '../lib/dom';
import { SITE } from '../site/site-config';

export function renderHeader(target: HTMLElement): void {
  const primaryLinks = SITE.navPrimary.map((link) =>
    createEl('a', { className: 'sv-nav__link', href: link.href }, [link.label])
  );

  const morePanel = createEl('div', { className: 'sv-nav-dropdown__panel', role: 'group' }, [
    ...SITE.navMore.map((link) =>
      createEl('a', { className: 'sv-nav__link sv-nav__link--dropdown', href: link.href }, [
        link.label,
      ])
    ),
  ]);

  const moreDropdown = createEl(
    'details',
    {
      className: 'sv-nav-dropdown',
    },
    [
      createEl(
        'summary',
        {
          className: 'sv-nav__summary',
          'aria-label': 'Más enlaces: audiencias, Latinoamérica, comunidad y opiniones',
        },
        [SITE.navMoreLabel]
      ),
      morePanel,
    ]
  );

  const contactLink = createEl(
    'a',
    { className: 'sv-nav__link sv-nav__link--accent', href: SITE.navContact.href },
    [SITE.navContact.label]
  );

  const adminHref = publicAsset(SITE.adminLogin.page);
  const businessHref = publicAsset(SITE.businessLogin.page);

  const desktopActions = createEl('div', { className: 'sv-header__actions' }, [
    createEl(
      'a',
      {
        className: 'sv-btn sv-btn--ghost sv-header__cta sv-header__cta-admin',
        href: adminHref,
      },
      [SITE.adminLogin.headerLabel]
    ),
    createEl(
      'a',
      {
        className: 'sv-btn sv-btn--ghost sv-header__cta sv-header__cta-business',
        href: businessHref,
      },
      [SITE.businessLogin.headerLabel]
    ),
    createEl(
      'a',
      {
        className: 'sv-btn sv-btn--primary sv-header__cta',
        href: '#funciones',
      },
      ['Explorar']
    ),
  ]);

  const menuToggle = createEl('button', {
    type: 'button',
    className: 'sv-header__menu-toggle',
    'aria-label': 'Abrir menú',
    'aria-expanded': 'false',
    'aria-controls': 'sv-mobile-nav',
  }) as HTMLButtonElement;
  menuToggle.innerHTML =
    '<span class="sv-header__menu-bars" aria-hidden="true"><span></span><span></span><span></span></span>';

  const mobilePanel = createEl(
    'div',
    {
      id: 'sv-mobile-nav',
      className: 'sv-mobile-nav',
      hidden: true,
      role: 'dialog',
      'aria-label': 'Menú de navegación e ingresos',
    },
    [
      createEl('p', { className: 'sv-mobile-nav__section-label' }, ['Ingresos']),
      createEl(
        'a',
        {
          className: 'sv-btn sv-btn--ghost sv-mobile-nav__cta sv-mobile-nav__cta--admin',
          href: adminHref,
        },
        [SITE.adminLogin.headerLabel]
      ),
      createEl(
        'a',
        {
          className: 'sv-btn sv-btn--ghost sv-mobile-nav__cta sv-mobile-nav__cta--business',
          href: businessHref,
        },
        [SITE.businessLogin.headerLabel]
      ),
      createEl(
        'a',
        {
          className: 'sv-btn sv-btn--primary sv-mobile-nav__cta',
          href: '#funciones',
        },
        ['Explorar']
      ),
      createEl('p', { className: 'sv-mobile-nav__section-label' }, ['Secciones']),
      createEl('nav', { className: 'sv-mobile-nav__links', 'aria-label': 'Secciones del sitio' }, [
        ...SITE.navPrimary.map((link) =>
          createEl('a', { className: 'sv-mobile-nav__link', href: link.href }, [link.label])
        ),
        ...SITE.navMore.map((link) =>
          createEl('a', { className: 'sv-mobile-nav__link', href: link.href }, [link.label])
        ),
        createEl('a', { className: 'sv-mobile-nav__link sv-mobile-nav__link--accent', href: SITE.navContact.href }, [
          SITE.navContact.label,
        ]),
      ]),
    ]
  );

  const setMenuOpen = (open: boolean): void => {
    menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    menuToggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    menuToggle.classList.toggle('sv-header__menu-toggle--open', open);
    mobilePanel.hidden = !open;
    document.body.classList.toggle('sv-mobile-nav-open', open);
  };

  menuToggle.addEventListener('click', () => {
    const open = menuToggle.getAttribute('aria-expanded') !== 'true';
    setMenuOpen(open);
  });

  mobilePanel.querySelectorAll('a').forEach((anchor) => {
    anchor.addEventListener('click', () => setMenuOpen(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menuToggle.getAttribute('aria-expanded') === 'true') {
      setMenuOpen(false);
    }
  });

  const header = createEl(
    'header',
    {
      className: 'sv-header',
      role: 'banner',
    },
    [
      createEl('div', { className: 'sv-header__inner sv-inner' }, [
        createEl('a', { className: 'sv-brand', href: '#inicio', 'aria-label': `${SITE.name} — inicio` }, [
          createEl('img', {
            className: 'sv-brand__logo',
            src: '/favicon.png',
            alt: '',
            width: '56',
            height: '56',
          }),
          createEl('span', { className: 'sv-brand__text' }, [SITE.name]),
        ]),
        createEl('nav', { className: 'sv-nav', 'aria-label': 'Principal' }, [
          ...primaryLinks,
          moreDropdown,
          contactLink,
        ]),
        desktopActions,
        menuToggle,
      ]),
      mobilePanel,
    ]
  );
  target.appendChild(header);
}
